function CustomDropdownMenuItem(_ref) {
  var component = _ref.component;
  return component;
}
export default CustomDropdownMenuItem;